/**
 * @generated SignedSource<<55f3ee9cdc45be5fe39459aa6f367b7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventGuestAssessmentResponsesInlineFragment$data = {
  readonly GAD: ReadonlyArray<{
    readonly id: string;
    readonly questionId: string;
    readonly questionResponse: number;
  }> | null;
  readonly PHQ: ReadonlyArray<{
    readonly id: string;
    readonly questionId: string;
    readonly questionResponse: number;
  }> | null;
  readonly Workplace: ReadonlyArray<{
    readonly id: string;
    readonly questionId: string;
    readonly questionResponse: number;
  }> | null;
  readonly submittedAt: any | null;
  readonly " $fragmentType": "eventGuestAssessmentResponsesInlineFragment";
};
export type eventGuestAssessmentResponsesInlineFragment$key = {
  readonly " $data"?: eventGuestAssessmentResponsesInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventGuestAssessmentResponsesInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "eventGuestAssessmentResponsesInlineFragment"
};

(node as any).hash = "516ae7204a7d764c398d90cfc57c575b";

export default node;
